import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, CircularProgress, Alert } from '@mui/material';
import { getAuth, onAuthStateChanged, User } from 'firebase/auth';
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  getDoc,
} from 'firebase/firestore';
import styles from './styles';
import { IAddress } from 'utils/types/User';
import { ISubscription } from 'utils/types/Subscription';

const MySubscription: React.FC = () => {
  const auth = getAuth();
  const db = getFirestore();

  const [, setUser] = useState<User | null>(null);
  const [subscriptions, setSubscriptions] = useState<ISubscription[]>([]);
  const [, setAddresses] = useState<IAddress[]>([]);

  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');

  // Observa autenticação e carrega dados
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async usr => {
      setUser(usr);
      if (usr) {
        try {
          // buscar assinatura do Firestore
          const userDoc = await getDoc(doc(db, 'subscription_users', usr.uid));

          if (userDoc.exists()) {
            const userData = userDoc.data();
            const subs: ISubscription[] = userData.subscriptions || [];

            setSubscriptions(subs);
          }

          // carrega endereços do Firestore
          setLoading(true);
          const colRef = collection(
            db,
            'subscription_users',
            usr.uid,
            'addresses',
          );
          const snapshot = await getDocs(colRef);
          const list: IAddress[] = snapshot.docs.map(docSnap => ({
            id: docSnap.id,
            ...(docSnap.data() as Omit<IAddress, 'id'>),
          }));
          setAddresses(list);
        } catch (err: any) {
          console.error('Erro ao carregar endereços:', err);
          setLoadError(err.message || 'Erro desconhecido');
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    });
    return () => unsub();
  }, []);

  // const handleToggleList = (e: React.MouseEvent) => {
  //   e.preventDefault();
  //   setShowList(prev => !prev);
  // };

  // const handleSelect = async (addr: IAddress) => {
  //   if (!user || !subscription) return;
  //   try {
  //     setLoading(true);
  //     const userDoc = doc(db, 'subscription_users', user.uid);
  //     await updateDoc(userDoc, {
  //       address: {
  //         street: addr.street,
  //         neighborhood: addr.neighborhood,
  //         city: addr.city,
  //         zip: addr.zip,
  //         number: addr.number,
  //         complement: addr.complement,
  //         recipient: addr.recipient,
  //         id: addr.id,
  //       },
  //     });
  //     setSubscription({ ...subscription, address: addr });
  //     setShowList(false);
  //   } catch (err: any) {
  //     console.error('Erro ao selecionar endereço:', err);
  //     setLoadError(err.message || 'Erro ao atualizar endereço');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (loadError) {
    return (
      <Box sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
        <Alert severity="error">{loadError}</Alert>
      </Box>
    );
  }

  if (!subscriptions.length) {
    return (
      <Box sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
        <Alert severity="info">Você ainda não possui assinaturas.</Alert>
      </Box>
    );
  }

  return (
    <Box sx={styles.container}>
      <Typography variant="h5" fontWeight="bold">
        MINHAS ASSINATURAS
      </Typography>
      <Typography variant="body2" sx={styles.subtitle}>
        *Valor do frete pode sofrer alteração com a mudança de endereço.
        <br />
      </Typography>
      {subscriptions.map((subscription, index) => (
        <Box key={index} sx={{ ...styles.cardBox, mb: 4 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              {/* <Box
                component="img"
                src={subscription.image}
                alt="Cervejas"
                sx={styles.imageStyle}
              /> */}
            </Grid>

            <Grid item xs={12} md={5}>
              <Typography sx={styles.boldGreenText}>
                {`${subscription.label} - ${subscription.type}`}
              </Typography>
              <Typography sx={styles.greenText}>
                Frete:{' '}
                {subscription.hasFreight
                  ? `R$ ${subscription.freightPrice}`
                  : 'GRÁTIS'}
              </Typography>

              <Typography mt={2} sx={styles.greenText}>
                Valor: R$ {subscription.price}
              </Typography>
              <Typography sx={styles.greenText}>
                Quantidade: {subscription.quantity}
              </Typography>
              <Typography sx={styles.idText}>
                Identificador: {subscription.id}
              </Typography>
            </Grid>

            <Grid item xs={12} md={3}>
              {/* <Typography sx={styles.statusTitle}>STATUS:</Typography> */}
              <Box
                sx={{
                  ...styles.statusBox,
                  color:
                    subscription.status.toUpperCase() === 'ATIVA'
                      ? '#388E3C'
                      : subscription.status.toUpperCase() ===
                          'AGUARDANDO PAGAMENTO'
                        ? '#FB8C00'
                        : subscription.status.toUpperCase() === 'SUSPENSO'
                          ? '#D32F2F'
                          : '#333',
                  borderColor:
                    subscription.status.toUpperCase() === 'ATIVA'
                      ? '#388E3C'
                      : subscription.status.toUpperCase() ===
                          'AGUARDANDO PAGAMENTO'
                        ? '#FB8C00'
                        : subscription.status.toUpperCase() === 'SUSPENSO'
                          ? '#D32F2F'
                          : '#333',
                }}
              >
                {subscription.status.toUpperCase()}
              </Box>
              {/* Endereço (se aplicável) pode ser incluído aqui também */}
            </Grid>
          </Grid>
        </Box>
      ))}

      {/* <Box sx={styles.cardBox}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Box
              component="img"
              src={subscription.image}
              alt="Cervejas"
              sx={styles.imageStyle}
            />
          </Grid>

          <Grid item xs={12} md={5}>
            <Typography sx={styles.boldGreenText}>
              Recorrência: {subscription.recurrence}
            </Typography>
            <Typography sx={styles.boldGreenText}>
              Cód: {subscription.code}
            </Typography>

            <Typography mt={2} sx={styles.greenText}>
              Valor do Produto: R$ {subscription.price}
            </Typography>
            <Typography sx={styles.greenText}>
              Quantidade: {subscription.quantity}
            </Typography>
          </Grid>

          <Grid item xs={12} md={3}>
            <Box sx={styles.statusBox}>
              STATUS: {subscription.status.toUpperCase()}
            </Box> */}

      {/* <Box display="flex" justifyContent="flex-end" gap={2}>
              <Link href="/addaddress" underline="hover">
                Incluir endereço
              </Link>
              <Link href="#" underline="hover" onClick={handleToggleList}>
                {showList ? 'Fechar' : 'Alterar'}
              </Link>
            </Box>

            {showList ? (
              <Grid container spacing={1} mt={1}>
                {addresses.length === 0 ? (
                  <Grid item xs={12}>
                    <Typography>Nenhum endereço cadastrado.</Typography>
                  </Grid>
                ) : (
                  addresses.map(addr => (
                    <Grid item xs={12} key={addr.id}>
                      <Paper
                        variant="outlined"
                        sx={{
                          ...styles.addressBox,
                          border:
                            addr.id === subscription.address.id
                              ? '2px solid #4caf50'
                              : '1px solid #ccc',
                          backgroundColor:
                            addr.id === subscription.address.id
                              ? 'rgba(76,175,80,0.1)'
                              : '#fff',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleSelect(addr)}
                      >
                        <Typography>
                          Endereço:{' '}
                          <strong>
                            {addr.street},{addr.number}
                          </strong>
                        </Typography>
                        <Typography>
                          Bairro: <strong>{addr.neighborhood}</strong>
                        </Typography>
                        <Typography>
                          Cidade: <strong>{addr.city}</strong>
                        </Typography>
                        <Typography>
                          CEP: <strong>{addr.zip}</strong>
                        </Typography>
                      </Paper>
                    </Grid>
                  ))
                )}
              </Grid>
            ) : (
              <Paper sx={styles.addressBox} elevation={0}>
                <Typography>
                  Endereço:{' '}
                  <strong>
                    {subscription.address.street}, {subscription.address.number}
                  </strong>
                </Typography>
                <Typography>
                  Bairro: <strong>{subscription.address.neighborhood}</strong>
                </Typography>
                <Typography>
                  Cidade: <strong>{subscription.address.city}</strong>
                </Typography>
                <Typography>
                  CEP: <strong>{subscription.address.zip}</strong>
                </Typography>
              </Paper>
            )}
          </Grid>
        </Grid>
      </Box> */}
    </Box>
  );
};

export default MySubscription;
